import { methods, request } from "./base";

const doctorApis = {
  getHospitalsInCityList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/doctor/get_hospital_in_city_list",
      payload: data,
    }),
  getDoctorsList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/doctor/get_doctor_in_hospital_list",
      payload: data,
    }),
  addDoctor: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/doctor/add_doctor",
      payload: data,
    }),
};

export default doctorApis;
